import React, { useState } from 'react';
import { AlertCircle, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Checkbox } from './ui/checkbox';

export const AgeVerificationModal = ({ isOpen, onClose, onConfirm, productName }) => {
  const [isVerified, setIsVerified] = useState(false);

  const handleConfirm = () => {
    if (isVerified) {
      onConfirm();
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-zinc-900 border-zinc-800 text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center space-x-2 text-xl">
            <AlertCircle className="w-6 h-6 text-red-500" />
            <span>Age Verification Required</span>
          </DialogTitle>
          <DialogDescription className="text-gray-300">
            This product contains alcohol and requires age verification
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="bg-red-900/20 border border-red-600/30 rounded-lg p-4">
            <p className="text-sm text-gray-300 leading-relaxed">
              <strong className="text-white">Legal Requirement:</strong> You must be 21 years of age or older to purchase alcoholic beverages in the United States.
            </p>
          </div>

          <div className="bg-zinc-800 rounded-lg p-4">
            <p className="text-sm text-gray-300 mb-3">
              By proceeding with this purchase, you certify that:
            </p>
            <ul className="text-sm text-gray-400 space-y-2 list-disc list-inside">
              <li>You are at least 21 years of age</li>
              <li>You will provide valid government-issued photo ID upon delivery</li>
              <li>You understand that adult signature is required at delivery</li>
              <li>You agree to our alcohol sales policy and terms</li>
            </ul>
          </div>

          <div className="flex items-start space-x-3 bg-zinc-800 p-4 rounded-lg">
            <Checkbox
              id="age-verify"
              checked={isVerified}
              onCheckedChange={setIsVerified}
              className="mt-1"
            />
            <label
              htmlFor="age-verify"
              className="text-sm text-white font-semibold cursor-pointer leading-relaxed"
            >
              I certify that I am 21 years of age or older and agree to the terms stated above.
            </label>
          </div>

          <div className="bg-amber-400/10 border border-amber-400/30 rounded-lg p-3">
            <p className="text-xs text-gray-400">
              <strong className="text-amber-400">Important:</strong> Failure to provide valid ID or if you are found to be under 21 years of age will result in order cancellation without refund.
            </p>
          </div>
        </div>

        <DialogFooter className="flex space-x-3">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1 border-zinc-700 text-white hover:bg-zinc-800"
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={!isVerified}
            className="flex-1 bg-amber-400 hover:bg-amber-500 text-black font-bold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isVerified ? (
              <>
                <CheckCircle className="w-4 h-4 mr-2" />
                Proceed to Payment
              </>
            ) : (
              'Confirm Age'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
